var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03-gift",
    "data-name": "03-gift"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 9h-5.82a6.507 6.507 0 0 1 -1.02-4.991c3.8.068 6.84 2.809 6.84 4.991z",
    fill: "#9547e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.84 4.007a6.507 6.507 0 0 1 -1.02 4.993h-5.82c0-2.182 3.04-4.923 6.84-4.993z",
    fill: "#9547e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 9c0-2.18-3.04-4.921-6.84-4.991a3.83 3.83 0 0 1 1.02-1.83c1.97-1.97 5.72-1.41 8.39 1.25a7.834 7.834 0 0 1 2.43 5.329c0 .08-.01.16-.01.24z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.84 4.007c-3.8.07-6.84 2.811-6.84 4.993h-4.99c0-.08-.01-.16-.01-.24a7.834 7.834 0 0 1 2.43-5.331c2.67-2.66 6.42-3.22 8.39-1.25a3.83 3.83 0 0 1 1.02 1.828z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.18 2.177a3.83 3.83 0 0 0 -1.02 1.83c.068 0 .133.01.2.013 2.01-1.771 5.616-1.176 8.209 1.407a8.514 8.514 0 0 1 2.158 3.573h1.263c0-.08.01-.16.01-.24a7.834 7.834 0 0 0 -2.43-5.331c-2.67-2.662-6.42-3.222-8.39-1.252z",
    fill: "#e1b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.639 4.02c.068 0 .133-.011.2-.013a3.83 3.83 0 0 0 -1.02-1.83c-1.969-1.97-5.719-1.41-8.389 1.25a7.834 7.834 0 0 0 -2.43 5.331c0 .08.01.16.01.24h1.263a8.514 8.514 0 0 1 2.157-3.571c2.593-2.583 6.199-3.178 8.209-1.407z",
    fill: "#e1b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.01 8.998h4.99v8h-1-8-1v-8h4.99z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 15a2.006 2.006 0 0 1 -2 2h-16v-8h16a2.006 2.006 0 0 1 2 2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 9v8h-16a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.01 8.998h4.99v8h-1-8-1v-8h4.99z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 15a2.006 2.006 0 0 1 -2 2h-16v-8h16a2.006 2.006 0 0 1 2 2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 9v8h-16a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 15h-14v-6h-2v8h16a2.006 2.006 0 0 0 2-2v-2a2.006 2.006 0 0 1 -2 2z",
    fill: "#adef3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 15h-14a2.006 2.006 0 0 1 -2-2v2a2.006 2.006 0 0 0 2 2h16v-8h-2z",
    fill: "#adef3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.99 11.998h.02 4.99v-3h-4.99-.02-4.99v3z",
    fill: "#e1b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 9h-16v3h16a2.006 2.006 0 0 1 2 2v-3a2.006 2.006 0 0 0 -2-2z",
    fill: "#dcff87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 12h16v-3h-16a2.006 2.006 0 0 0 -2 2v3a2.006 2.006 0 0 1 2-2z",
    fill: "#dcff87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 8.998h2v3h-2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 8.998h2v3h-2z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 14.998h10v2h-10z",
    fill: "#c17ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.16 4.007a5.368 5.368 0 0 0 -.054 2.279c.018-.093.03-.188.054-.278a7.848 7.848 0 0 1 6.094 2.992h.746c0-2.182-3.04-4.923-6.84-4.993z",
    fill: "#863dcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.84 6.008c.024.09.036.185.054.278a5.368 5.368 0 0 0 -.054-2.279c-3.8.07-6.84 2.811-6.84 4.993h.746a7.848 7.848 0 0 1 6.094-2.992z",
    fill: "#863dcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.254 7a3.527 3.527 0 0 1 .746 2h3.727a8.05 8.05 0 0 0 -.918-2z",
    fill: "#c17ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.273 9h3.727a3.527 3.527 0 0 1 .746-2h-3.555a8.05 8.05 0 0 0 -.918 2z",
    fill: "#c17ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.809 7a8.05 8.05 0 0 1 .918 2h1.263c0-.08.01-.16.01-.24a6.287 6.287 0 0 0 -.273-1.76z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.273 7a6.287 6.287 0 0 0 -.273 1.758c0 .08.01.16.01.24h1.263a8.05 8.05 0 0 1 .918-2z",
    fill: "#cd8ef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 16.998h8v30.002h-8z",
    fill: "#9547e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 17v30h-14a2.006 2.006 0 0 1 -2-2v-28z",
    fill: "#ff8bbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17h15v28a2.006 2.006 0 0 1 -2 2h-14v-30z",
    fill: "#ff8bbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 16.998h16v3h-16z",
    fill: "#cc4271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16.998h16v3h-16z",
    fill: "#cc4271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 16.998h8v3h-8z",
    fill: "#863dcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16.998h2v3h-2z",
    fill: "#bf1e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 19.998h2v27.002h-2z",
    fill: "#ff7cac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 16.998h2v3h-2z",
    fill: "#bf1e68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 19.998h2v27.002h-2z",
    fill: "#ff7cac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 44h8v3h-8z",
    fill: "#863dcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 44a2.006 2.006 0 0 1 -2-2v3a2.006 2.006 0 0 0 2 2h14v-3z",
    fill: "#ff639b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 44h-14v3h14a2.006 2.006 0 0 0 2-2v-3a2.006 2.006 0 0 1 -2 2z",
    fill: "#ff639b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 34.717a35.508 35.508 0 0 0 8 4.35v-19.067h-8z",
    fill: "#a457f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.251 20a22.31 22.31 0 0 0 7.749 13.113v-13.113z",
    fill: "#ffa6c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 39.786a44.467 44.467 0 0 0 14 2.214v-22h-14z",
    fill: "#ffa6c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 39.067c.653.256 1.322.494 2 .719v-19.786h-2z",
    fill: "#ff8bbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 20h-2v13.113c.636.555 1.3 1.092 2 1.6z",
    fill: "#ff8bbb"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bef748",
    height: 1,
    rx: 0.5,
    width: 6,
    x: 35,
    y: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.5 10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 -.5.5z",
    fill: "#bef748"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9547e9",
    height: 1,
    rx: 0.5,
    width: 4,
    x: 21,
    y: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 45.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 -.5.5z",
    fill: "#9547e9"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#edc8ff",
    height: 1,
    rx: 0.5,
    width: 6,
    x: 20,
    y: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 -.5.5z",
    fill: "#edc8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 45.5c0 .276.168.5.375.5h11.25c.207 0 .375-.224.375-.5s-.168-.5-.375-.5h-11.25c-.207 0-.375.224-.375.5z",
    fill: "#ff3d86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.5 45.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 -.5.5z",
    fill: "#ff3d86"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ddf0fe"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.003,
    cy: 28.987,
    rx: 1.642,
    ry: 2.286,
    transform: "matrix(.707 -.707 .707 .707 -8.777 36.793)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 24,
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 -5.251 35.329)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 3,
    rx: 0.825,
    ry: 1.148,
    transform: "matrix(.707 -.707 .707 .707 6.965 22.807)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.746,
    cy: 2.5,
    rx: 0.413,
    ry: 0.574,
    transform: "matrix(.707 -.707 .707 .707 7.83 23.896)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.746,
    cy: 10.5,
    rx: 0.413,
    ry: 0.574,
    transform: "matrix(.707 -.707 .707 .707 5.689 34.729)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftNote);
export default __webpack_public_path__ + "static/media/giftNote.6ca2d9d7e273079cb1d8ba6cd2317fb0.svg";
export { ForwardRef as ReactComponent };